module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/store_images/2@2x_ca51e8424b21e5eee67b170a80989355.png";